/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * NOTE: using traditional object notation with prototype is not possible, because diretives are not managed as
 * object instances, simply as standalone function containers. They are not considered
 * as stateful objects (at least the call of their functions is made in a procedural way, no scoping).
 */
/** @ngInject */
function PermissionOnlyFactory($log, authenticationService) {
    const permission = {
        restrict: 'A'
    };

    /**
     * Checks if the user is authenticated and has the roles given in the attribute 'permission-only'. The attribute
     * supports the following syntax:
     * <ul>
     * <li>permission-only="ADMIN" => checks if the user has the ADMIN role.</li>
     * <li>permission-only="'ADMIN'" => checks if the user has the ADMIN role.</li>
     * <li>permission-only="['ADMIN', 'USER']" => checks if the user has the ADMIN or the USER role.</li>
     * </ul>
     * The element is removed from the DOM tree if the syntax is invalid, or the user is not authenticated or doesn't
     * one of the specified role.
     *
     * @param {Object} scope Directive' scope.
     * @param {DOMElement} element DOM element the 'permission-only' attribute is applied on.
     * @param {Object} attributes Attributes in the previous element.
     */
    permission.link = function(scope, element, attributes) {
        if (attributes.permissionOnly) {
            let roles;
            if (attributes.permissionOnly.startsWith('\'') || attributes.permissionOnly.startsWith('[')) {
                roles = scope.$eval(attributes.permissionOnly);
            } else {
                roles = attributes.permissionOnly;
            }
            if (angular.isString(roles)) {
                roles = [roles];
            }
            if (!angular.isArray(roles) || !authenticationService.userHasRole(roles)) {
                element.remove();
            }
        }
    };

    $log.debug('Factory \'PermissionOnly\' loaded');
    return permission;
}

export { PermissionOnlyFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/security/component/PermissionOnly.js